import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Tooltip,
  useMediaQuery,
  useTheme,
  Icons,
  Button,
} from '@ublend-npm/aulaui-core';
import {
  LINK_ASSIGNMENTS_NO_DESTINATION,
  LINK_ASSIGNMENTS_TOOLTIP,
  LINK_EXTENSION_BUTTON_TEXT,
} from '@app/constants/texts';
import { getAssignments } from '@core/assignments/selectors';
import { Assignment } from '@core/assignments/types';
import { AulaState } from '@core/types/state';
import ConversionModalContainer from './ConversionModal.container';
import filterDestinationAssignmentsForConversion from './filterDestinationAssignmentsForConversion';

type ConversionSectionProps = {
  assignment: Assignment;
  styles: { purpleButton: any };
};

const ConversionSection = ({ assignment, styles }: ConversionSectionProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [isConvertingExtension, setIsConvertingExtension] = useState(false);
  const assignments = useSelector((state: AulaState) => getAssignments(state));

  const availableDestinationAssignments =
    filterDestinationAssignmentsForConversion(
      (assignments as any) || [],
      assignment as any
    );
  const hasAvailableDestinationAssignments =
    availableDestinationAssignments?.length > 0;
  const tooltipTitle = hasAvailableDestinationAssignments
    ? LINK_ASSIGNMENTS_TOOLTIP
    : LINK_ASSIGNMENTS_NO_DESTINATION;
  const assignmentId = assignment.id || assignment.objectId || '';

  return (
    <>
      <Box component="span" sx={{ display: 'inline-flex' }}>
        <Tooltip
          placement="bottom"
          disableInteractive
          title={tooltipTitle}
          disableFocusListener={isMobile}
          disableHoverListener={isMobile}
          disableTouchListener={isMobile}
        >
          <Button
            kind="secondary"
            sx={{
              ...styles.purpleButton,
            }}
            disabled={!hasAvailableDestinationAssignments}
            aria-label={LINK_ASSIGNMENTS_TOOLTIP}
            onClick={() => setIsConvertingExtension(true)}
          >
            <Icons.CompareArrowsOutlined fontSize="small" aria-hidden />
            {LINK_EXTENSION_BUTTON_TEXT}
          </Button>
        </Tooltip>
      </Box>
      {isConvertingExtension && (
        <ConversionModalContainer
          open={isConvertingExtension}
          assignmentId={assignmentId}
          onModalClose={(openConvertedExtension) => {
            setIsConvertingExtension(false);
            if (typeof openConvertedExtension === 'function') {
              openConvertedExtension();
            }
          }}
        />
      )}
    </>
  );
};

export default ConversionSection;
